<template>
  <ion-page>
    <ion-content
      fullscreen="true"
      class="eventpage"
      :scroll-events="enableScrollEvent"
      @ionScroll="onScroll"
    >
      <main>
        <div class="w-full h-full min-h-screen bg-[#F6F4F0]">
          <slot class="flex-1 page-bottom-padding" test="test"> </slot>
        </div>
      </main>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent } from '@ionic/vue';
import { lockToPortrait } from '@/utils/screen-orientation';

export default {
  name: 'FormsLayout',
  components: {
    IonPage,
    IonContent,
  },
  props: {
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onScroll(event) {
      this.$emit('on-scroll', event);
    },
  },
  async mounted() {
    await lockToPortrait();
  },
  async beforeUnmount() {
    await lockToPortrait();
  },
};
</script>
